import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import dayjs from 'dayjs'

const abpApplicationConfigurationApi = new AbpApplicationConfigurationApi()
const dataCategoryApi = new DataCategoryApi()

// 表单字段为空， null，重置或者删除
const deleteFormField = (formData) => {
  const data = Object.fromEntries(
    Object.entries(formData).filter(([key, value]) => {
      return value !== null && value !== undefined && value !== ''
    })
  )
  return data
}
// 时间格式处理
const dealTimeField = (formData) => {
  const data = JSON.parse(JSON.stringify(formData))
  // 时间格式处理
  Object.keys(data).forEach((key) => {
    // eslint-disable-next-line no-restricted-globals
    if (dayjs(data[key]).isValid() && isNaN(data[key])) {
      data[key] = dayjs(data[key]).format('YYYY-MM-DD HH:mm:ss')
    }
  })
  return data
}

const getDataCategory = async (codeList = [], values = [], vue) => {
  const [configError, abpConfigList] = await abpApplicationConfigurationApi.get()
  if (!configError) {
    const codes = []
    codeList.forEach((item) => {
      codes.push(abpConfigList.setting.values[item])
    })
    const [statusError, statusRes] = await dataCategoryApi.getListByCodes({
      codes,
      includeDetails: true,
    })
    const codeMap = codes.reduce((pre, code, index) => {
      pre[code] = values[index]
      return pre
    }, {})
    if (!statusError) {
      const [err, res] = await dataCategoryApi.getListByIds({
        ids: statusRes.map((item) => {
          return item.id
        }),
        includeDetails: true,
      })
      if (!err) {
        res.forEach((item) => {
          vue[codeMap[item.code]] = item.dataItems.map((i) => {
            return {
              value: i.code,
              label: i.displayName,
              ...i,
            }
          })
        })
      }
    }
  }
}

const numToChines = (num) => {
  const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const unit = ['', '十', '百', '千', '万']
  num = parseInt(num)
  const getWan = (temp) => {
    const strArr = temp
      .toString()
      .split('')
      .reverse()
    let newNum = ''
    const newArr = []
    strArr.forEach((item, index) => {
      newArr.unshift(item === '0' ? changeNum[item] : changeNum[item] + unit[index])
    })
    const numArr = []
    newArr.forEach((m, n) => {
      if (m !== '零') numArr.push(n)
    })
    if (newArr.length > 1) {
      newArr.forEach((m, n) => {
        if (newArr[newArr.length - 1] === '零') {
          if (n <= numArr[numArr.length - 1]) {
            newNum += m
          }
        } else {
          newNum += m
        }
      })
    } else {
      newNum = newArr[0]
    }
    return newNum
  }
  const overWan = Math.floor(num / 10000)
  let noWan = num % 10000
  if (noWan.toString().length < 4) {
    noWan = `0${noWan}`
  }
  return overWan ? `${getWan(overWan)}万${getWan(noWan)}` : getWan(num)
}

export default {
  deleteFormField,
  dealTimeField,
  getDataCategory,
  numToChines,
}
